import { render, staticRenderFns } from "./SortPanelContainerNew.vue?vue&type=template&id=49be7df6&scoped=true&"
import script from "./SortPanelContainerNew.vue?vue&type=script&lang=ts&"
export * from "./SortPanelContainerNew.vue?vue&type=script&lang=ts&"
import style0 from "./SortPanelContainerNew.vue?vue&type=style&index=0&id=49be7df6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49be7df6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VListItemTitle,VRow})
